import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 700px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Accessibility = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const Icon = styled.img`
  width: 50px;
  height: 50px;
  cursor: pointer;

  border-radius: 8px;

  ${({ theme, selected }) =>
    selected &&
    `
      border: 2px solid ${theme.colors.primary.vividCerulean};
      `}
`;
